import { RelatedToType } from '@shared/enums';
import { Dictionary } from 'tsui';

export const getObjectIconMap = (isNewNavigationOn: boolean): Dictionary<string> => {
  return {
    [RelatedToType.Project]: isNewNavigationOn ? 'handshake' : 'heroicons_outline:cash',
    [RelatedToType.Contact]: 'heroicons_outline:user-group',
    [RelatedToType.Company]: 'heroicons_outline:user-group',
    [RelatedToType.Property]: 'heroicons_outline:office-building',
    [RelatedToType.PropertyTenant]: 'heroicons_outline:office-building',
    [RelatedToType.Task]: isNewNavigationOn ? 'list-checks' : 'heroicons_outline:clipboard-list',
    [RelatedToType.CustomObject]: 'heroicons_outline:qrcode',
  };
};

export const iconMap = {
  'heroicons_outline:user-group': 'contact',
  'heroicons_outline:qrcode': 'database',
  'heroicons_outline:office-building': 'building-2',
  'heroicons_outline:globe': 'map',
};
